import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { ValueType } from 'react-select'

const DropDownComponent = React.lazy(() => import('app/components/DropDownComponent'))

export interface IOption {
  value: string
  label: string
}

export const renderDropDown = (
  name: string,
  options: IOption[],
  container: Element,
  selectValue: ValueType<IOption, false>,
  setSelectValue: (value: ValueType<IOption, false>) => void,
  afterRender?: () => void,
) => {
  ReactDOM.render(
    <DropDownComponent
      name={name}
      options={options}
      selectValue={selectValue}
      setSelectValue={(val) => setSelectValue(val)}
    />,
    container,
    afterRender,
  )
}
